/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: ImportOnly = 0, ExportOnly = 1, TwoWay = 2
 */
export enum Routemize_Entities_Calendar_External_ExternalCalendarSyncDirection {
    IMPORT_ONLY = 'ImportOnly',
    EXPORT_ONLY = 'ExportOnly',
    TWO_WAY = 'TwoWay',
}
